(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-products-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('free-products-popup')) {
    customElements.define(
      'free-products-popup',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.storageKey = this.dataset.storageKey;
          this.onePerVisit = this.dataset.repeatMode === 'session';
          this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleSectionSelect = this.handleSectionSelect.bind(this);
          this.updateReadMore = this.updateReadMore.bind(this);

          // 'Lees meer' op mobiel: knop alleen tonen als de tekst echt langer is dan de ingestelde regels.
          this.querySelectorAll('.free-products-popup__read-more').forEach((button) => {
            button.addEventListener('click', () => {
              const wrapper = button.closest('[data-free-products-popup-readmore]');
              const expanded = wrapper.classList.toggle('is-expanded');
              button.setAttribute('aria-expanded', String(expanded));
              button.textContent = expanded ? button.dataset.less : button.dataset.more;
            });
          });
          window.addEventListener('resize', this.updateReadMore);

          this.querySelectorAll('[data-free-products-popup-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });

          this.querySelectorAll('[data-free-products-popup-cta]').forEach((link) => {
            link.addEventListener('click', () => this.markSeen());
          });

          this.dialog.addEventListener('close', () => this.markSeen());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog && this.dataset.closeOnBackdrop === 'true') {
              this.dialog.close();
            }
          });
          document.addEventListener('shopify:section:select', this.handleSectionSelect);

          if (!this.designMode && this.wasSeen()) return;
          if (this.dataset.autoOpen === 'false') return;

          if (this.dataset.trigger === 'scroll') {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            this.handleScroll();
          } else {
            const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
            this.openTimer = window.setTimeout(() => this.open(), delay);
          }
        }

        disconnectedCallback() {
          window.clearTimeout(this.openTimer);
          window.removeEventListener('scroll', this.handleScroll);
          window.removeEventListener('resize', this.updateReadMore);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        }

        // Spring naar het kaartje (en de tab) met dit product, bijv. het herenvest als er herenproducten in de cart zitten.
        showProduct(productId) {
          const cards = Array.from(this.querySelectorAll('free-socks-product'));
          for (const card of cards) {
            const index = (card.products || []).findIndex((product) => product.id === productId);
            if (index === -1) continue;

            const carousel = card.closest('free-socks-carousel');
            const panel = card.closest('[data-panel]');
            if (carousel && panel && typeof carousel.selectTab === 'function') {
              carousel.selectTab(Number(panel.dataset.panel));
            }
            const track = card.closest('.free-socks-carousel__track');
            const item = card.closest('.free-socks-picker__item');
            if (track && item) track.scrollLeft = item.offsetLeft - track.offsetLeft;
            if (panel && carousel) carousel.update(panel);

            const swatch = card.querySelector(`[data-free-socks-swatch][value="${index}"]`);
            if (swatch && !swatch.checked) {
              swatch.checked = true;
              card.selectProduct(index);
            }
            return;
          }
        }

        updateReadMore() {
          this.querySelectorAll('[data-free-products-popup-readmore]').forEach((wrapper) => {
            const button = wrapper.querySelector('.free-products-popup__read-more');
            const inner = wrapper.querySelector('.free-products-popup__text-inner');
            if (!button || !inner || wrapper.classList.contains('is-expanded')) return;
            button.hidden = inner.scrollHeight <= inner.clientHeight + 1;
          });
        }

        handleSectionSelect(event) {
          if (event.target && event.target.contains(this)) this.open(true);
        }

        handleScroll() {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
          if (progress >= Number(this.dataset.scrollPercent)) this.open();
        }

        open(force) {
          if (!this.dialog || this.dialog.open || (!force && this.hasOpened)) return;
          this.hasOpened = true;
          window.removeEventListener('scroll', this.handleScroll);
          this.dialog.showModal();
          this.updateReadMore();
          if (!force) this.markSeen();
        }

        getCartSections() {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
            return cartDrawer.getSectionsToRender().map((section) => section.id);
          }
          const cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
            return cartItems.getSectionsToRender().map((section) => section.section);
          }
          return ['cart-icon-bubble'];
        }

        addToCart(variantId) {
          const body = JSON.stringify({
            id: variantId,
            quantity: 1,
            sections: this.getCartSections(),
            sections_url: window.location.pathname,
          });
          return fetch(`${window.routes.cart_add_url}.js`, { ...fetchConfig(), body }).then((response) => response.json());
        }

        // Ververs de cart zoals het thema dat doet: drawer via renderContents, cartpagina via dezelfde sections als CartItems.
        onAdded(response) {
          const sections = response.sections || {};

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            this.dialog.close();
            cartDrawer.classList.remove('is-empty');
            cartDrawer.renderContents(response);
            return;
          }

          const cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
            cartItems.getSectionsToRender().forEach((section) => {
              const sectionElement = document.getElementById(section.id);
              const sectionHTML = sections[section.section];
              if (!sectionElement || !sectionHTML) return;
              const elementToReplace = sectionElement.querySelector(section.selector) || sectionElement;
              elementToReplace.innerHTML = cartItems.getSectionInnerHTML(sectionHTML, section.selector);
            });
            cartItems.classList.remove('is-empty');
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.remove('is-empty');
            this.dialog.close();
            return;
          }

          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            const source = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (source) bubble.innerHTML = source.innerHTML;
          }
        }

        // 'Eén keer per bezoek': onthouden binnen de sessie. 'Tot er sokken in de winkelwagen zitten' beslist de server.
        wasSeen() {
          if (!this.onePerVisit) return false;
          try {
            return window.sessionStorage.getItem(this.storageKey) === 'seen';
          } catch (error) {
            return false;
          }
        }

        markSeen() {
          if (!this.onePerVisit || this.designMode) return;
          try {
            window.sessionStorage.setItem(this.storageKey, 'seen');
          } catch (error) {
            return;
          }
        }
      }
    );
  }

  if (!customElements.get('free-socks-carousel')) {
    customElements.define(
      'free-socks-carousel',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-panel]'));

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(Number(tab.dataset.tab)));
          });

          this.panels.forEach((panel) => {
            const track = panel.querySelector('.free-socks-carousel__track');
            const prev = panel.querySelector('[data-carousel-prev]');
            const next = panel.querySelector('[data-carousel-next]');
            if (!track || !prev || !next) return;
            prev.addEventListener('click', () => this.go(panel, -1));
            next.addEventListener('click', () => this.go(panel, 1));
            track.addEventListener('scroll', () => this.update(panel), { passive: true });
          });
        }

        selectTab(index) {
          this.tabs.forEach((tab, tabIndex) => tab.setAttribute('aria-selected', String(tabIndex === index)));
          this.panels.forEach((panel, panelIndex) => {
            panel.hidden = panelIndex !== index;
          });
          const panel = this.panels[index];
          if (panel) this.update(panel);
        }

        current(panel) {
          const track = panel.querySelector('.free-socks-carousel__track');
          if (!track || !track.clientWidth) return 0;
          return Math.round(track.scrollLeft / track.clientWidth);
        }

        go(panel, step) {
          const track = panel.querySelector('.free-socks-carousel__track');
          const items = track.children;
          const target = Math.max(0, Math.min(items.length - 1, this.current(panel) + step));
          track.scrollTo({ left: items[target].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        }

        update(panel) {
          const counter = panel.querySelector('[data-carousel-counter]');
          const prev = panel.querySelector('[data-carousel-prev]');
          const next = panel.querySelector('[data-carousel-next]');
          if (!counter) return;
          const total = Number(counter.dataset.total) || 1;
          const index = Math.min(total - 1, this.current(panel));
          counter.textContent = `${index + 1} / ${total}`;
          if (prev) prev.disabled = index === 0;
          if (next) next.disabled = index === total - 1;
        }
      }
    );
  }

  if (!customElements.get('free-socks-product')) {
    customElements.define(
      'free-socks-product',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.form = this.querySelector('form');
          this.picker = this.closest('.free-socks-picker');
          this.popup = this.closest('free-products-popup');
          this.button = this.querySelector('[data-free-socks-add]');
          this.idInput = this.form.querySelector('input[name="id"]');
          this.optionsContainer = this.querySelector('[data-free-socks-options]');
          const caret = this.querySelector('[data-free-socks-caret]');
          this.caretHTML = caret ? caret.innerHTML : '';

          try {
            this.products = JSON.parse(this.querySelector('[data-free-socks-products]').textContent);
          } catch (error) {
            this.products = [];
          }
          this.product = this.products[Number(this.dataset.initialIndex) || 0];
          if (!this.product) return;

          const swatch = this.querySelector(`[data-free-socks-swatch][value="${Number(this.dataset.initialIndex) || 0}"]`);
          if (swatch) swatch.checked = true;

          this.form.addEventListener('change', (event) => {
            if (event.target.matches('[data-free-socks-swatch]')) {
              this.selectProduct(Number(event.target.value));
            } else if (event.target.matches('[data-free-socks-option]')) {
              this.onOptionChange();
            }
          });
          this.form.addEventListener('submit', (event) => this.onSubmit(event));
          this.onOptionChange();
        }

        text(key) {
          return (this.picker && this.picker.dataset[key]) || '';
        }

        getSelects() {
          return Array.from(this.querySelectorAll('[data-free-socks-option]'));
        }

        // Andere kleur = ander product: maat-keuzes opnieuw opbouwen en de gekozen maat zo mogelijk behouden.
        selectProduct(index) {
          const product = this.products[index];
          if (!product) return;

          const previous = {};
          this.getSelects().forEach((select) => {
            previous[select.dataset.optionName] = select.value;
          });

          this.product = product;
          const fallback = product.variants.find((variant) => variant.available) || product.variants[0];
          this.optionsContainer.innerHTML = '';
          product.options.forEach((option) => {
            const id = `${this.dataset.cardId}-${index}-${option.index}`;
            const wrapper = document.createElement('div');
            wrapper.className = 'free-socks-picker__option';

            const label = document.createElement('label');
            label.className = 'free-socks-picker__label';
            label.htmlFor = id;
            label.textContent = option.name;

            const selectWrapper = document.createElement('div');
            selectWrapper.className = 'select';
            const select = document.createElement('select');
            select.id = id;
            select.className = 'select__select free-socks-picker__select';
            select.dataset.freeSocksOption = '';
            select.dataset.optionIndex = option.index;
            select.dataset.optionName = option.name;
            option.values.forEach((value) => select.add(new Option(value, value)));
            const keep = previous[option.name];
            select.value = keep && option.values.includes(keep) ? keep : fallback.options[option.index];

            selectWrapper.append(select);
            selectWrapper.insertAdjacentHTML('beforeend', this.caretHTML);
            wrapper.append(label, selectWrapper);
            this.optionsContainer.append(wrapper);
          });

          this.onOptionChange();
        }

        onOptionChange() {
          const selects = this.getSelects();
          this.variant = this.product.variants.find((variant) =>
            selects.every((select) => variant.options[Number(select.dataset.optionIndex)] === select.value)
          );
          this.setError('');
          this.render();
        }

        render() {
          const product = this.product;
          const variant = this.variant;
          this.idInput.value = variant ? variant.id : '';

          this.querySelectorAll('[data-free-socks-link]').forEach((link) => {
            link.href = product.url;
          });
          const title = this.querySelector('[data-free-socks-title]');
          if (title && !this.hasAttribute('data-fixed-title')) title.textContent = product.title;
          const colorName = this.querySelector('[data-free-socks-color-name]');
          if (colorName) colorName.textContent = product.color;

          const price = this.querySelector('.price');
          if (price && variant) {
            price.classList.toggle('price--on-sale', variant.onSale);
            price.classList.toggle('price--sold-out', !variant.available);
            price.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach((item) => {
              item.textContent = variant.price;
            });
            const compare = price.querySelector('.price__sale .price__compare .price-item--regular');
            if (compare) compare.textContent = variant.compareAtPrice;
          }

          const value = this.querySelector('[data-free-socks-value]');
          if (value && variant) value.textContent = variant.value;

          const stock = this.querySelector('[data-free-socks-stock]');
          if (stock) {
            stock.textContent = variant ? variant.stock : this.text('textUnavailable');
            stock.dataset.state = variant ? variant.stockState : 'sold-out';
          }

          const image = this.querySelector('.free-socks-picker__media img');
          const imageSrc = (variant && variant.image) || product.image;
          if (image && imageSrc && image.getAttribute('src') !== imageSrc) {
            image.removeAttribute('srcset');
            image.src = imageSrc;
          }

          const available = Boolean(variant && variant.available);
          this.button.disabled = !available;
          if (available) {
            this.setLabel(this.text('textAdd'));
          } else {
            this.setLabel(variant ? this.text('textSoldOut') : this.text('textUnavailable'));
          }
        }

        setLabel(label) {
          this.button.querySelectorAll('[data-free-socks-label]').forEach((element) => {
            element.textContent = label;
          });
        }

        setError(message) {
          const error = this.querySelector('[data-free-socks-error]');
          if (!error) return;
          error.textContent = message;
          error.hidden = !message;
        }

        onSubmit(event) {
          event.preventDefault();
          if (!this.popup || !this.variant || !this.variant.available) return;
          if (this.button.getAttribute('aria-disabled') === 'true') return;

          this.setError('');
          this.button.setAttribute('aria-disabled', 'true');
          this.button.classList.add('loading');

          this.popup
            .addToCart(this.variant.id)
            .then((response) => {
              if (response.status) {
                this.setError(response.description || response.message || this.text('textError'));
                return;
              }
              this.setLabel(this.text('textAdded'));
              window.setTimeout(() => this.render(), 2000);
              this.popup.onAdded(response);
            })
            .catch((error) => {
              console.error(error);
              this.setError(this.text('textError'));
            })
            .finally(() => {
              this.button.classList.remove('loading');
              this.button.removeAttribute('aria-disabled');
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.shopify-section-header');
this.headerWrapper = document.querySelector('.header-wrapper')
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;

//if (this.headerIsAlwaysSticky) {
//this.header.classList.add('shopify-section-header-sticky');
//this.header.classList.add('always-fixed');
//};

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;
this.searchOverlay = document.querySelector('.search-modal__overlay');

	if (this.searchOverlay) {
		this.searchOverlay.addEventListener('click', function(){
			const searchModal = document.querySelector('details-modal');
			searchModal.close();
		})
	}

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 50) {
	this.header.classList.add('shopify-section-header-sticky');
};

if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight / 2) {
	this.header.classList.remove('shopify-section-header-sticky');
};
if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
}else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (document.querySelector('.steps-section')) {
              ScrollTrigger.getAll().forEach((el) => el.kill());

              const setStepsParallaxOpt = (elem) => {
                elem.setAttribute('data-parallax-property-value', '-40');
                elem.setAttribute('data-parallax-steps', '0, 40');
                elem.setAttribute('data-parallax-property', 'translateY');
              };

              const removeStepsParallaxOpt = (elem) => {
                elem.removeAttribute('data-parallax-property-value');
                elem.removeAttribute('data-parallax-steps');
                elem.removeAttribute('data-parallax-property');
                elem.removeAttribute('style');
              };

              const calcDurationScroll = (elem) => {
                switch (elem.length) {
                  case 1:
                    return 'bottom bottom';
                  case 2:
                    return '+=80%';
                  case 3:
                    return '+=140%';
                  case 4:
                    return '+=180%';
                  case 5:
                    return '+=200%';
                }
              };

              const initStepsParallax = () => {
                const stepsSections = document.querySelectorAll('.steps-section');

                stepsSections.forEach((elem) => {
                  const parallax = elem.querySelectorAll('.steps__scroll-parallax');

                  parallax.forEach((elem) => {
                    if (window.matchMedia('(min-width: 990px)').matches) {
                      elem.classList.add('js-parallax');
                      setStepsParallaxOpt(elem);
                    } else {
                      elem.classList.remove('js-parallax');
                      removeStepsParallaxOpt(elem);
                    }
                  });
                });
              };

              const initStepsAnim = () => {
                const containers = document.querySelectorAll('.steps');

                containers.forEach((elem) => {
                  ScrollTrigger.matchMedia({
                    '(min-width: 990px)': function () {
                      const slides = elem.querySelectorAll('.steps__slide-item--desktop');
                      let parallax = elem.querySelector('.steps__scroll');
                      let progress = [];

                      slides.forEach((elem, index) => {
                        progress.push((1 / slides.length) * index - 1 / slides.length / 2);
                      });

                      progress.push(1);

                      const removeActiveClass = () => {
                        slides.forEach((elem) => {
                          elem.classList.remove('active');
                        });
                      };

                      let st = ScrollTrigger.create({
                        trigger: elem,
                        start: 'top top',
                        end: calcDurationScroll(slides),
                        invalidateOnRefresh: true,
                        animation: parallax
                          ? gsap.fromTo(parallax, { y: 0 }, { y: -(parallax.scrollHeight - elem.clientHeight + 310) })
                          : false,
                        pin: true,
                        scrub: 0.5,
                        onRefresh: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              removeActiveClass();
                              slides[0].classList.remove('active');
                              slides[i].classList.add('active');
                              slides[i].classList.remove('prev');
                            }
                          }
                        },
                        onUpdate: (self) => {
                          for (let i = 0; i <= slides.length; i++) {
                            if (self.progress > progress[i] && self.progress < progress[i + 1]) {
                              if (!slides[i].classList.contains('active')) {
                                removeActiveClass();
                                slides[i].classList.add('active');
                                slides[i].classList.remove('prev');

                                for (let el of slides) {
                                  if (el.classList.contains('active')) break;
                                  el.classList.add('prev');
                                }
                              }
                            }
                          }
                        },
                      });
                    },
                    '(max-width: 989px)': function () {
                      if (elem.querySelector('.steps__scroll') !== null) {
                        elem.querySelector('.steps__scroll').style.transform = 'translate3d(0, 0, 0)';
                        ScrollTrigger.getAll().forEach((el) => el.kill());
                      }
                    },
                  });
                });
              };

              setTimeout(() => {
                initStepsAnim();
                initStepsParallax();
              }, 300);
            }
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["we-walk-campaign-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('we-walk-campaign-popup')) {
    customElements.define(
      'we-walk-campaign-popup',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;

          this.storageKey = this.dataset.storageKey;
          this.hideForSession = this.dataset.hideForSession === 'true';
          this.designMode = Boolean(window.Shopify && window.Shopify.designMode);
          this.handleScroll = this.handleScroll.bind(this);
          this.handleSectionSelect = this.handleSectionSelect.bind(this);

          this.querySelectorAll('[data-we-walk-popup-close]').forEach((button) => {
            button.addEventListener('click', () => this.dialog.close());
          });

          this.querySelectorAll('[data-we-walk-popup-cta]').forEach((link) => {
            link.addEventListener('click', () => this.markSeen());
          });

          this.dialog.addEventListener('close', () => this.markSeen());
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog && this.dataset.closeOnBackdrop === 'true') {
              this.dialog.close();
            }
          });
          document.addEventListener('shopify:section:select', this.handleSectionSelect);

          if (!this.designMode && this.wasSeen()) return;

          if (this.dataset.trigger === 'scroll') {
            window.addEventListener('scroll', this.handleScroll, { passive: true });
            this.handleScroll();
          } else {
            const delay = Math.max(0, Number(this.dataset.delay) || 0) * 1000;
            this.openTimer = window.setTimeout(() => this.open(), delay);
          }
        }

        disconnectedCallback() {
          window.clearTimeout(this.openTimer);
          window.removeEventListener('scroll', this.handleScroll);
          document.removeEventListener('shopify:section:select', this.handleSectionSelect);
        }

        handleSectionSelect(event) {
          if (event.target && event.target.contains(this)) this.open(true);
        }

        handleScroll() {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
          if (progress >= Number(this.dataset.scrollPercent)) this.open();
        }

        open(force) {
          if (!this.dialog || this.dialog.open || (!force && this.hasOpened)) return;
          this.hasOpened = true;
          window.removeEventListener('scroll', this.handleScroll);
          this.dialog.showModal();
        }

        wasSeen() {
          if (!this.hideForSession) return false;
          try {
            return window.sessionStorage.getItem(this.storageKey) === 'closed';
          } catch (error) {
            return false;
          }
        }

        markSeen() {
          if (!this.hideForSession || this.designMode) return;
          try {
            window.sessionStorage.setItem(this.storageKey, 'closed');
          } catch (error) {
            return;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
